import { createFormHookContexts, type AnyFieldApi } from '@tanstack/react-form';
import { ChevronDownIcon } from 'lucide-react';
import type { ComponentProps } from 'react';
import { cn } from '../../lib/utils';

// TODO: We're passing field.state instead of field to avoid this bad behavior of tanstack form with react compiler:
// https://github.com/TanStack/form/issues/1379
export function FieldInfo({ fieldState }: { fieldState: AnyFieldApi['state'] }) {
	return fieldState.meta.isTouched && !fieldState.meta.isValid ? (
		<p data-slot="form-message" className="text-destructive m-1 text-sm">
			{fieldState.meta.errors.map((error) => (typeof error === 'string' ? error : error.message)).join(', ')}
		</p>
	) : null;
}

export function Select(props: ComponentProps<'select'> & { variant?: 'default' | 'outline' }) {
	return (
		<>
			<select
				{...props}
				className={cn(
					// Default options from shadcn select component
					"border-input data-[placeholder]:text-muted-foreground [&_svg:not([class*='text-'])]:text-muted-foreground focus-visible:border-ring focus-visible:ring-ring/50 aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive dark:bg-input/30 dark:hover:bg-input/50 shadow-xs flex w-fit items-center justify-between gap-2 whitespace-nowrap rounded-md border bg-transparent px-3 py-2 text-sm outline-none transition-[color,box-shadow] focus-visible:ring-[3px] disabled:cursor-not-allowed disabled:opacity-50 data-[size=default]:h-9 data-[size=sm]:h-8 *:data-[slot=select-value]:line-clamp-1 *:data-[slot=select-value]:flex *:data-[slot=select-value]:items-center *:data-[slot=select-value]:gap-2 [&_svg:not([class*='size-'])]:size-4 [&_svg]:pointer-events-none [&_svg]:shrink-0",
					// Custom:
					'text-foreground h-12 w-full appearance-none truncate pb-0 pl-3 pr-10 pt-4',
					props.variant === 'outline' && 'border-foreground bg-transparent! rounded-[12px]',
					props.value && 'filled',
					props.className,
				)}
			>
				{props.children}
			</select>
			<ChevronDownIcon className="text-muted-foreground pointer-events-none absolute top-3 right-3 size-6" />
		</>
	);
}

export const { fieldContext, formContext, useFieldContext, useFormContext } = createFormHookContexts();
